import { render, staticRenderFns } from "./CheckExaminationScore.vue?vue&type=template&id=4a97a1dd&"
import script from "./CheckExaminationScore.vue?vue&type=script&lang=js&"
export * from "./CheckExaminationScore.vue?vue&type=script&lang=js&"
import style0 from "./CheckExaminationScore.vue?vue&type=style&index=0&id=4a97a1dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports